import { For, Show, createEffect, createMemo } from "solid-js";

import AffiliateClaiTip from "@/components/Base/AffiliateClaiTip";
import { Tooltips } from "@/components/Base/Tooltip";
import Icon, { svgPathTypes } from "@/components/Icon";
import { GameLineSportId } from "@/enum/game";
import { useLiveChat } from "@/hooks/livechat/useLiveChat.ts";
import { useRouter } from "@/hooks/useRouter.tsx";
import { useShare } from "@/hooks/useShare";
import { useReactiveT } from "@/i18n";
import { copyText } from "@/lib/helper";
import { isMobile } from "@/lib/isMobile";
import { getImgUrlPro, getImgurl } from "@/lib/resFolder";
import { removeLocalePrefix } from "@/lib/urlUtils";
import { configStore } from "@/stores/configStore";
import { sidebarStore } from "@/stores/sidebar";
import { userStore } from "@/stores/userStore";
import { useLocation } from "@solidjs/router";

export default function Menu(props: { onClose?: () => void }) {
  const { push, toSport } = useRouter();
  const t = useReactiveT();
  const { shareLink } = useShare();
  const { clickLiveChat } = useLiveChat();
  const location = useLocation();
  const isShowSports = createMemo(
    () => configStore.frontCfgMap["WebsiteConfigV2"]?.sport_config || {},
  );

  createEffect(() => {
    console.log(location.pathname);
  });

  const jumpTo = (path: string) => {
    props.onClose?.();
    push(path);
  };

  const menulist1 = [
    {
      path: "/vip",
      label: "home.vip_club",
      iconSrc: getImgUrlPro("vip_club.svg", "menu"),
      action: () => jumpTo("/vip"),
      isShow: true,
      box: true,
    },
    {
      path: "/bonus-center",
      label: "home.bonus",
      iconSrc: getImgUrlPro("bonus.svg", "menu"),
      action: () => jumpTo("/bonus-center"),
      box: true,
    },
    // {
    //   path: "/wager-contest",
    //   label: "home.wager_contest",
    //   iconSrc: getImgUrlPro("tournament.svg", "menu"),
    //   action: () => jumpTo("/wager-contest"),
    //   box: true,
    // },
    {
      path: "/affiliate",
      label: "home.affiliate",
      iconSrc: getImgUrlPro("affiliate.svg", "menu"),
      action: () => jumpTo("/affiliate"),
      box: true,
      showRedDot: userStore.affiliateRewardTip,
    },
    {
      path: "/promotion",
      label: "home.promotions",
      iconSrc: getImgUrlPro("promotions.svg", "menu"),
      action: () => jumpTo("/promotion"),
      box: true,
    },
    // {
    //   path: "/tournament",
    //   label: TOURNAMENT_TRANSLATE.TITLE,
    //   iconSrc: getImgUrlPro("tournament.svg", "menu"),
    //   action: () => jumpTo("tournament"),
    //   box: true,
    // },
  ];
  if (isShowSports()?.is_show) {
    menulist1.push({
      path: "/sports",
      label: "menu.sports_news",
      iconSrc: getImgurl("sports.png", "common/home"),
      action: () => {
        props.onClose?.();
        toSport(GameLineSportId);
      },
      box: true,
    });
  }
  const menulist2 = [
    {
      path: "/help",
      label: "help.title",
      icon: "menu/question" as svgPathTypes,
      action: () => push("/help"),
    },
    {
      path: "/feedback",
      label: "home.feedback",
      icon: "menu/notification" as svgPathTypes,
      action: () => push("/feedback"),
    },
    {
      label: "home.live_support",
      icon: "menu/headphones" as svgPathTypes,
      action: () => clickLiveChat(),
    },
    // {
    //   label: "account.language",
    //   icon: "menu/globe" as svgPathTypes,
    //   action: () => showDialog({ type: DialogType.SwitchLanguage }),
    // },
  ];

  type MenuList3Item = {
    path?: string;
    label: string;
    icon?: svgPathTypes;
    iconSrc?: string;
    imgSrc?: string;
    action: () => void;
    box?: boolean;
  };
  const menulist3: Array<MenuList3Item> = [
    {
      label: "help.title",
      imgSrc: getImgUrlPro("side_copy_link.png", "menu"),
      action: () => jumpTo("/affiliate"),
      box: true,
    },
    {
      label: "help.title",
      imgSrc: getImgUrlPro("side_bonus.png", "menu"),
      action: () => jumpTo("/bonus-center"),
      box: true,
    },
    {
      label: "help.title",
      imgSrc: getImgUrlPro("side_vip.png", "menu"),
      action: () => jumpTo("/vip"),
      box: true,
    },
    ...menulist1,
    ...menulist2,
  ];

  const renderMenuItem = (item: MenuList3Item) => (
    <div
      class="flex h-12 w-12 cursor-pointer items-center justify-center rounded-[8px]"
      classList={{
        "bg-[var(--colors-surface-bg-8)]": item.box,
        "hover:bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]":
          !item.imgSrc && sidebarStore.state.isExpanded,
        "hover:bg-[var(--colors-fade-success-20)] hover:border-[1px] hover:border-[var(--colors-btn-border-default-2)]":
          !item.imgSrc && !sidebarStore.state.isExpanded,
        "!bg-[var(--colors-fade-success-20)] border-[1px] border-[var(--colors-btn-border-default-2)]":
          item.path !== undefined &&
          removeLocalePrefix(location.pathname).startsWith(item.path),
      }}
      onClick={item.action}
    >
      {item.icon && (
        <Icon
          class="h-7 w-7"
          color="var(--colors-icon-tab-default)"
          name={item.icon}
        />
      )}
      {item.iconSrc && <img class="h-7 w-7" src={item.iconSrc} alt="" />}
      {item.imgSrc && <img class="h-full w-full" src={item.imgSrc} alt="" />}
    </div>
  );

  return (
    <div class="flex flex-col items-center gap-3 font-['Onest']">
      {(isMobile() || sidebarStore.state.isExpanded) && (
        <>
          {/* 邀请 */}
          <div
            class="rounded-(--md) bg-(--colors-surface-bg-7) flex h-40 w-full cursor-pointer flex-col justify-between bg-cover bg-center bg-no-repeat py-3 pl-3 pr-[67px]"
            style={{
              "background-image": `url("${getImgUrlPro("copy_link.png", "menu")}")`,
            }}
            onClick={() => jumpTo("/affiliate")}
          >
            <div class="flex-1">
              <div class="gap-(--core-spacing-1) flex items-center">
                <Icon name="menu/users" class="h-4 w-4 shrink-0" />
                <span class="text-(--colors-text-tertiary) text-xs font-bold leading-3">
                  {t()("home.referandearn")}
                </span>
              </div>
              <div class="text-(--colors-text-primary) mt-2 text-lg font-bold leading-[18px]">
                {t()("home.withdrawrefercash")}
              </div>
            </div>
            <div
              class="rounded-(--md) border-(--colors-btn-border-default) bg-main-linear px-(--core-spacing-4) py-(--core-spacing-3) flex h-[38px] w-fit items-center justify-center border"
              onClick={(e) => {
                e.stopPropagation();
                if (!userStore.isLogin) {
                  jumpTo("/register");
                  return;
                }
                copyText(shareLink());
              }}
            >
              <div class="leading-3.5 text-(--colors-text-brand) text-[14px] font-bold">
                {t()("home.copy_link")}
              </div>
            </div>
          </div>
          {/* bonus & vip */}
          <div class="gap-(--core-spacing-2) flex w-full items-center justify-between">
            <div
              class="rounded-(--md) bg-(--colors-surface-bg-7) flex h-[81px] flex-1 cursor-pointer flex-col justify-between bg-cover bg-top bg-no-repeat pt-3 text-center"
              style={{
                "background-image": `url("${getImgUrlPro("bonus.png", "menu")}")`,
              }}
              onclick={() => jumpTo("/bonus-center")}
            >
              <span class="leading-3.5 text-(--colors-text-primary) text-[14px] font-bold">
                {t()("home.sidebar_bonus")}
              </span>
            </div>
            <div
              class="rounded-(--md) bg-(--colors-surface-bg-7) flex h-[81px] flex-1 cursor-pointer flex-col justify-between bg-cover bg-top bg-no-repeat pt-3 text-center"
              style={{
                "background-image": `url("${getImgUrlPro("vip.png", "menu")}")`,
              }}
              onclick={() => jumpTo("/vip")}
            >
              <span class="leading-3.5 text-(--colors-text-primary) text-[14px] font-bold">
                {t()("home.sidebar_vip")}
              </span>
            </div>
          </div>
          {/* points games */}
          {/* <div
            class="w-full overflow-hidden rounded-[var(--md)] bg-[var(--colors-surface-bg-8)] hover:bg-[linear-gradient(270deg,var(--colors-border-top-banner-r)_13.46%,var(--colors-border-icon-green-l)_100%)]"
            onClick={() => jumpTo("/bonus-game")}
            classList={{
              "active:bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]":
                isMobile(),
              "!bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]":
                removeLocalePrefix(location.pathname).startsWith("/bonus-game"),
            }}
          >
            <div class="gap-(--core-spacing-2) p-(--core-spacing-3) flex cursor-pointer items-center">
              <img class="h-5 w-5" src={getImgUrlPro("points.svg", "menu")} />
              <span class="leading-3.5 text-(--colors-text-primary) text-[14px] font-bold">
                {t()("home.points_games")}
              </span>
            </div>
          </div> */}
          {/* sub menus */}
          <div class="gap-(--custom-spacing-2) rounded-(--md) bg-(--colors-surface-bg-8) p-(--custom-spacing-6) flex w-full flex-col justify-start">
            <For each={menulist1}>
              {(item) => (
                <div
                  class="gap-(--core-spacing-2) rounded-(--md) p-(--core-spacing-2) flex cursor-pointer items-center justify-start hover:bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]"
                  classList={{
                    "active:bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]":
                      isMobile(),
                    "!bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]":
                      removeLocalePrefix(location.pathname).startsWith(
                        item.path,
                      ),
                  }}
                  onClick={item.action}
                >
                  <img src={item.iconSrc} class="h-5 w-5" />
                  <span class="leading-3.5 text-(--colors-text-tertiary) text-[14px] font-bold">
                    {t()(item.label)}
                  </span>
                  <Show when={item.showRedDot} fallback={<></>}>
                    <AffiliateClaiTip
                      class={
                        sidebarStore.state.isExpanded
                          ? "right-[-6px] top-1/2 -translate-y-1/2"
                          : "left-[-14px] top-[6px]"
                      }
                    />
                  </Show>
                </div>
              )}
            </For>
          </div>
          {/* download */}
          <div
            class="h-[70px] w-full cursor-pointer px-3 pt-3"
            style={{
              background: `url("${getImgUrlPro("download.png", "menu")}") no-repeat center center / 100% 100% `,
            }}
            onclick={() => jumpTo("/install")}
          >
            <div class="text-(--colors-text-primary) leading-3.5 mb-1 w-[111px] text-[14px] font-bold">
              {t()("home.download_app")}
            </div>
            <div class="text-(--colors-text-secondary) w-[111px] break-all text-[12px] font-medium leading-[15px]">
              {t()("home.exclusive_bonus")}
            </div>
          </div>
          {/* bottom menus */}
          <div class="gap-(--custom-spacing-2) rounded-(--md) bg-(--colors-surface-bg-8) p-(--custom-spacing-6) flex w-full flex-col justify-start">
            <For each={menulist2}>
              {(item) => (
                <div
                  class="gap-(--core-spacing-2) rounded-(--md) p-(--core-spacing-2) flex cursor-pointer items-center justify-start hover:bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]"
                  classList={{
                    "active:bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]":
                      isMobile(),
                    "!bg-[linear-gradient(90deg,var(--colors-fade-success-20)_0%,var(--colors-fade-success-0)_100%)]":
                      item.path
                        ? removeLocalePrefix(location.pathname).startsWith(
                            item.path,
                          )
                        : false,
                  }}
                  onClick={item.action}
                >
                  <Icon
                    name={item.icon}
                    color="var(--colors-icon-tab-default)"
                    class="h-5 w-5"
                  />
                  <span class="leading-3.5 text-(--colors-text-tertiary) text-[14px] font-bold">
                    {t()(item.label)}
                  </span>
                </div>
              )}
            </For>
          </div>
        </>
      )}
      {!isMobile() && !sidebarStore.state.isExpanded && (
        <div class="flex flex-col gap-1.5">
          <For each={menulist3}>
            {(item, index) =>
              index() < 3 ? (
                renderMenuItem(item)
              ) : (
                <Tooltips
                  content={t()(item.label)}
                  placement="right"
                  offset={12}
                  arrowColor="text-[#363838]"
                  contentClass="bg-[#363838] text-[14px] leading-5 text-[#C9D5DF] font-semibold !font-['Inter']"
                >
                  {renderMenuItem(item)}
                </Tooltips>
              )
            }
          </For>
        </div>
      )}
    </div>
  );
}
